import React, { useEffect } from 'react';
import '../../styles/mainContents.css'
import { useSelector, useDispatch, connect } from 'react-redux';
import { Link, Switch, useHistory } from 'react-router-dom';
import MainHeader from './MainHeader';
import Invoices from '../page/InvoicePages/Invoices';
//import StatusUpdate from '../page/LandingPage/StatusUpdate';


function InvoiceLayout(props) {

  const dispatch = useDispatch();
  const history = useHistory();
  //const handleOnClick = () => history.push('localhost:3000/login');

  const { authreducer, transferState, transferDetailState } = props;

  return (
    <div className="mainCN">
      <main className='MainPageCN'>
        <div>      
          <section> 
            <MainHeader pageTitle=" - Invoices"/> 

            <table className=''>
              <thead>
                <tr></tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={'2'}>
                    {/* <StatusUpdate/> */}
                  </td>
                </tr>
                <tr>
                  <td>
                    <Invoices/>
                  </td>
                </tr>
              </tbody>              
            </table>   
          </section>     
        </div>

      </main>


    </div>
    
  );

  
}


const mapStateToProps = (state) => {
 return {
   authreducer: state.authreducer,
  //  transferState: state.transfer['items_fetchTransfers'],
  // transferDetailState: state.transfer['items_fetchTransfernoDetail'],   
 }

};

const mapDispatchToProps = (dispatch) => {
  return {

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceLayout);